import { radioIcon } from "assets/images";

const RadioCheckBoxIcon = () => {
  return <img src={radioIcon} alt="checkbox" />;
};

export default RadioCheckBoxIcon;
